import {getAssetPrefix} from "./env";

export function assetPath(path: string): string {
    const prefix = getAssetPrefix();
    return `${prefix}${path.startsWith("/") ? path : "/" + path}`;
}
